export default __webpack_public_path__ + "static/media/signin-background.311cb611.png";